// Added By Farhan Khan on 26-Dec-2025 Using this to Manage Remark Column on List View Components (AMC Ticket)
import React, { useState } from "react";

const ReadMoreText = ({ text, wordLimit = 20 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return "-";

  const words = text.split(" ");

  if (words.length <= wordLimit) {
    return <span>{text}</span>;
  }

  return (
    <span>
      {expanded
        ? text
        : words.slice(0, wordLimit).join(" ") + "... "}
      <span
        onClick={() => setExpanded(!expanded)}
        style={{
          color: "#0d6efd",
          cursor: "pointer",
          fontWeight: 500,
        }}
      >
        {expanded ? " Read Less" : " Read More"}
      </span>
    </span>
  );
};

export default ReadMoreText;